import packageJson from "../../package.json";

/** App version sourced from the root package metadata. */
export const APP_VERSION = packageJson.version;
